import React, { ReactNode } from 'react'
import styles from './filter-menu-header.module.scss'
import { ClassNameProps, PropsFrom } from 'types/utilities'
import cx from 'classnames'

interface HeaderBtn {
  content: ReactNode
  onClick: () => void
  disabled?: boolean
  btnProps?: PropsFrom<HTMLButtonElement>
}

export interface Props extends ClassNameProps {
  title: string
  btnLeft?: HeaderBtn
  btnRight?: HeaderBtn
}

const FilterMenuHeader = ({ title, btnLeft, btnRight, className }: Props) => {
  return (
    <header className={cx(styles.header, className)}>
      <section className={cx(styles.section, styles.left)} aria-hidden={!btnLeft}>
        {btnLeft && (
          <button
            {...(btnLeft.btnProps ?? {})}
            onClick={btnLeft.onClick}
            disabled={btnLeft.disabled}
          >
            {btnLeft.content}
          </button>
        )}
      </section>
      <h1 className={cx(styles.section, styles.center)}>{title}</h1>
      <section className={cx(styles.section, styles.right)} aria-hidden={!btnRight}>
        {btnRight && (
          <button
            {...(btnRight.btnProps ?? {})}
            onClick={btnRight.onClick}
            disabled={btnRight.disabled}
          >
            {btnRight.content}
          </button>
        )}
      </section>
    </header>
  )
}

export default FilterMenuHeader
